import React, { Component } from 'react'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'

export default class OverviewDashboard extends Component {
  render() {
    return (
      <PageContainer backgroundColor="#fafbfb" hideTitle>
        <div>Dashboard</div>
      </PageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/dashboard/OverviewDashboard.js